import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=1ddc77a6&scoped=true&"
import script from "./Contents.vue?vue&type=script&lang=ts&"
export * from "./Contents.vue?vue&type=script&lang=ts&"
import style0 from "./Contents.vue?vue&type=style&index=0&id=1ddc77a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc77a6",
  null
  
)

export default component.exports